import React, { useEffect, useMemo, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon';
import { useGetSdkVersionSubscribersQuery, useSendNewsletterMutation } from '../../api/sdkVersionSubscribersApiSlice';
import useCustomTable from '../tables/useCustomTable';
import Table from '../tables/Table';

const NewsletterModal = ({show, onClose, sdkVersion}) => {
  const [users, setUsers] = useState([])
  const { data: subscribers, isSuccess: isSubscribersSuccess } = useGetSdkVersionSubscribersQuery(sdkVersion)
  const [sendNewsletter] = useSendNewsletterMutation();
  const { t } = useTranslation()
  const {
    tableProps,
  } = useCustomTable({
    sortable: true,
    paginate: false,
    sortBy: {email: 'asc'}
  });
  const columns = useMemo(() => [{
    Header: "",
    Cell: ({row}) => ( <Form.Check type="checkbox"
                checked={isSelected(row.original.id)}
                onChange={(e)=>( toogleUser(row.original.id, e.target.checked) )}
                />),
    disableSortBy: true,
    accessor: 'id',
  },{
    Header: t("users.email"),
    accessor: 'email',
  }]);

  useEffect(() => {
    if(subscribers) {
      setUsers(subscribers.users.map((u)=>(u.id)))
    }
  }, [subscribers])

  const isSelected = (id) => {
    return users.includes(id)
  }

  const toogleUser = (id, value) => {
    if (value) {
      setUsers([...users, id])
    } else {
      const idx = users.indexOf(id)
      setUsers([...users.slice(0, idx), ...users.slice(idx+1)])
    }
  }

  const onSubmit = ()=>{
    sendNewsletter([sdkVersion, {userIds: users}]).then(()=>{
      onClose()
    })
  }

  return (
  <Modal show={show} onHide={onClose} size={"lg"}>
    <Modal.Title>{t("sdkVersion.newsletter")}</Modal.Title>
    <Modal.Body>
      <div style={{maxHeight: '75vh', overflowY: 'scroll'}}>
        {subscribers && <Table
                data={subscribers.users}
                columns={columns}
                onRowClick={(r)=>{toogleUser(r.id, !isSelected(r.id))}}
                small
                {...tableProps} />}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>
        {t("cancel")}
      </Button>
      <Button key="submit" type="submit" variant="primary" onClick={onSubmit}>
        <Icon icon='send' text={t("send")}/>
      </Button>
    </Modal.Footer>
  </Modal>
  )
}

export default NewsletterModal